// extracted by mini-css-extract-plugin
module.exports = {"m1cc4mek":"m1cc4mek"};